<div class="row">
  <div class="col-md-6">
    <div class="mb-6">
      <textbox [caption]="'User Name'" [formData]="entity" [maxlength]="20" [mandatory]="true" (change)="nameChanged()"
        [fieldName]="'UserName'" [(ngModel)]="entity.UserName" ngDefaultControl></textbox>
    </div>
  </div>
  <div class="col-md-6">
    <div class="mb-6">
      <textbox [caption]="'Email'" [maxlength]="50" [mandatory]="true" [fieldName]="'Email'" [formData]="entity"
        [disabled]="true" [formData]="entity" [fieldName]="'Email'" [(ngModel)]="entity.Email" ngDefaultControl>
      </textbox>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-md-6">
    <div class="mb-6">
      <textbox [caption]="'Phone Number'" [(ngModel)]="entity.PhoneNumber" [maxlength]="10" [formData]="entity"
        [disabled]="true" [mandatory]="true" [fieldName]="'PhoneNumber'" ngDefaultControl>
      </textbox>
    </div>
  </div>
  <div class="col-md-3">
    <div class="g-otp">
      <btn [label]="'Generate OTP'" (click)="generateOtp()" [class]="'btn btn-primary float-start me-2'" [type]="'button'">
      </btn>
    </div>
  </div>
</div> 
<div class="row mt-3">
  <div class="col-md-6">
    <div class="mb-6">
      <textbox [caption]="'Otp'" [disabled]="disableOtp" [maxlength]="6" (keypress)="numberOnly($event)"
        [formData]="entity" [fieldName]="'Otp'" [(ngModel)]="entity.Otp" (change)="otpChange()" [mandatory]="true"
        [disabled]="disableSave" ngDefaultControl>
      </textbox>
    </div>
  </div>
  <div class="col-md-6">
    <div class="mb-6">
      <label>New Password <span style="color: red">*</span></label>
      <input type="password" class="form-control" (change)="checkValidPassword()" [disabled]="dispassword"
        [maxlength]="10" [(ngModel)]="entity.password" placeholder="Password" ngDefaultControl />
    </div>
  </div>
</div>
<div class="mt-3">
  <btn [label]="'Save'" (click)="save($event)" [disabled]="disableSave" [class]="'btn-1 btn-11'"
    [type]="'button'"></btn>
</div>